import { render, staticRenderFns } from "./CourseShowTeacher.vue?vue&type=template&id=2d9d1e8a&scoped=true&"
import script from "./CourseShowTeacher.vue?vue&type=script&lang=js&"
export * from "./CourseShowTeacher.vue?vue&type=script&lang=js&"
import style0 from "./CourseShowTeacher.vue?vue&type=style&index=0&id=2d9d1e8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9d1e8a",
  null
  
)

export default component.exports